import { variants as AddColumnLeftVariants } from './IconAddColumnLeft';
import { variants as AddColumnRightVariants } from './IconAddColumnRight';
import { variants as AddLinkVariants } from './IconAddLink';
import { variants as AddReactionVariants } from './IconAddReaction';
import { variants as AddRowAboveVariants } from './IconAddRowAbove';
import { variants as AddRowBelowVariants } from './IconAddRowBelow';
import { variants as AdjustToneVariants } from './IconAdjustTone';
import { variants as AiVariants } from './IconAi';
import { variants as AiAgentVariants } from './IconAiAgent';
import { variants as AiComposeVariants } from './IconAiCompose';
import { variants as AlarmClockVariants } from './IconAlarmClock';
import { variants as AlertCircleVariants } from './IconAlertCircle';
import { variants as AlertHexagonVariants } from './IconAlertHexagon';
import { variants as AlertSquareVariants } from './IconAlertSquare';
import { variants as AlertTriangleVariants } from './IconAlertTriangle';
import { variants as AlignLeftVariants } from './IconAlignLeft';
import { variants as AlignVerticalCenterVariants } from './IconAlignVerticalCenter';
import { variants as ArchiveVariants } from './IconArchive';
import { variants as ArchiveOffVariants } from './IconArchiveOff';
import { variants as ArrowBlockLeftVariants } from './IconArrowBlockLeft';
import { variants as ArrowBlockRightVariants } from './IconArrowBlockRight';
import { variants as ArrowCircleBrokenRightVariants } from './IconArrowCircleBrokenRight';
import { variants as ArrowNarrowDownVariants } from './IconArrowNarrowDown';
import { variants as ArrowNarrowDownRightVariants } from './IconArrowNarrowDownRight';
import { variants as ArrowNarrowLeftVariants } from './IconArrowNarrowLeft';
import { variants as ArrowNarrowRightVariants } from './IconArrowNarrowRight';
import { variants as ArrowNarrowUpVariants } from './IconArrowNarrowUp';
import { variants as ArrowNarrowUpRightVariants } from './IconArrowNarrowUpRight';
import { variants as AtSignVariants } from './IconAtSign';
import { variants as AuditLogVariants } from './IconAuditLog';
import { variants as AutopilotVariants } from './IconAutopilot';
import { variants as BadgeCounterVariants } from './IconBadgeCounter';
import { variants as BarChart01Variants } from './IconBarChart01';
import { variants as BarChart10Variants } from './IconBarChart10';
import { variants as Bell01Variants } from './IconBell01';
import { variants as BellOff01Variants } from './IconBellOff01';
import { variants as BlockCornerUpLeftVariants } from './IconBlockCornerUpLeft';
import { variants as BlockCornerUpRightVariants } from './IconBlockCornerUpRight';
import { variants as Bold01Variants } from './IconBold01';
import { variants as BookClosedVariants } from './IconBookClosed';
import { variants as BookOpen01Variants } from './IconBookOpen01';
import { variants as BookmarkVariants } from './IconBookmark';
import { variants as BracketsEllipsesVariants } from './IconBracketsEllipses';
import { variants as BrainVariants } from './IconBrain';
import { variants as BranchingRuleVariants } from './IconBranchingRule';
import { variants as Briefcase01Variants } from './IconBriefcase01';
import { variants as Briefcase01PlusVariants } from './IconBriefcase01Plus';
import { variants as Briefcase02Variants } from './IconBriefcase02';
import { variants as Building05Variants } from './IconBuilding05';
import { variants as BusinessHoursVariants } from './IconBusinessHours';
import { variants as CalendarVariants } from './IconCalendar';
import { variants as CalendarCheck02Variants } from './IconCalendarCheck02';
import { variants as CalendarDateVariants } from './IconCalendarDate';
import { variants as CalendarPlus02Variants } from './IconCalendarPlus02';
import { variants as CaretCollapseVariants } from './IconCaretCollapse';
import { variants as CaretExpandVariants } from './IconCaretExpand';
import { variants as CaretUpDownVariants } from './IconCaretUpDown';
import { variants as ChatVariants } from './IconChat';
import { variants as ChatDeflectedVariants } from './IconChatDeflected';
import { variants as CheckVariants } from './IconCheck';
import { variants as CheckCircleVariants } from './IconCheckCircle';
import { variants as CheckSquareVariants } from './IconCheckSquare';
import { variants as CheckVerified02Variants } from './IconCheckVerified02';
import { variants as ChevronDownVariants } from './IconChevronDown';
import { variants as ChevronLeftVariants } from './IconChevronLeft';
import { variants as ChevronRightVariants } from './IconChevronRight';
import { variants as ChevronUpVariants } from './IconChevronUp';
import { variants as CircleVariants } from './IconCircle';
import { variants as ClockVariants } from './IconClock';
import { variants as ClockCheckVariants } from './IconClockCheck';
import { variants as ClockRecentlyViewedVariants } from './IconClockRecentlyViewed';
import { variants as ClockRewindVariants } from './IconClockRewind';
import { variants as ClockSnoozeVariants } from './IconClockSnooze';
import { variants as CloudOffVariants } from './IconCloudOff';
import { variants as Code01Variants } from './IconCode01';
import { variants as Columns03Variants } from './IconColumns03';
import { variants as CompassVariants } from './IconCompass';
import { variants as ConnectorsVariants } from './IconConnectors';
import { variants as ContactAutoVariants } from './IconContactAuto';
import { variants as Contrast02Variants } from './IconContrast02';
import { variants as ConversationVariants } from './IconConversation';
import { variants as ConversationSearchVariants } from './IconConversationSearch';
import { variants as CopilotVariants } from './IconCopilot';
import { variants as Copy01Variants } from './IconCopy01';
import { variants as Copy06Variants } from './IconCopy06';
import { variants as CopyFileVariants } from './IconCopyFile';
import { variants as CornerDownRightVariants } from './IconCornerDownRight';
import { variants as CornerUpLeftVariants } from './IconCornerUpLeft';
import { variants as CornerUpLeftDoubleVariants } from './IconCornerUpLeftDouble';
import { variants as CornerUpRightVariants } from './IconCornerUpRight';
import { variants as CpuChip01Variants } from './IconCpuChip01';
import { variants as CreditCard02Variants } from './IconCreditCard02';
import { variants as CrownVariants } from './IconCrown';
import { variants as Cube01Variants } from './IconCube01';
import { variants as Cube01OffVariants } from './IconCube01Off';
import { variants as CubeOutlineVariants } from './IconCubeOutline';
import { variants as CurrencyDollarVariants } from './IconCurrencyDollar';
import { variants as CursorClickVariants } from './IconCursorClick';
import { variants as CustomerPortalVariants } from './IconCustomerPortal';
import { variants as Dataflow02Variants } from './IconDataflow02';
import { variants as DeleteVariants } from './IconDelete';
import { variants as DeliverabilityVariants } from './IconDeliverability';
import { variants as Diamond01Variants } from './IconDiamond01';
import { variants as DiscussionsVariants } from './IconDiscussions';
import { variants as DiscussionsDepreciatedVariants } from './IconDiscussionsDepreciated';
import { variants as DistributeSpacingVerticalVariants } from './IconDistributeSpacingVertical';
import { variants as DividerVariants } from './IconDivider';
import { variants as DonutChartVariants } from './IconDonutChart';
import { variants as DoorOpenVariants } from './IconDoorOpen';
import { variants as DotVariants } from './IconDot';
import { variants as Dotpoints01Variants } from './IconDotpoints01';
import { variants as DotsGridVariants } from './IconDotsGrid';
import { variants as DotsHorizontalVariants } from './IconDotsHorizontal';
import { variants as DotsVerticalVariants } from './IconDotsVertical';
import { variants as Download02Variants } from './IconDownload02';
import { variants as Edit01Variants } from './IconEdit01';
import { variants as Edit05Variants } from './IconEdit05';
import { variants as EmojiVariants } from './IconEmoji';
import { variants as EmojiActivityVariants } from './IconEmojiActivity';
import { variants as EmojiFoodVariants } from './IconEmojiFood';
import { variants as EmojiNatureVariants } from './IconEmojiNature';
import { variants as EmojiSymbolsVariants } from './IconEmojiSymbols';
import { variants as Expand01Variants } from './IconExpand01';
import { variants as ExportVariants } from './IconExport';
import { variants as EyeVariants } from './IconEye';
import { variants as EyeOffVariants } from './IconEyeOff';
import { variants as FaceHappyVariants } from './IconFaceHappy';
import { variants as FaceSmileVariants } from './IconFaceSmile';
import { variants as FeatherVariants } from './IconFeather';
import { variants as FieldCustomVariants } from './IconFieldCustom';
import { variants as File02Variants } from './IconFile02';
import { variants as File05Variants } from './IconFile05';
import { variants as FileCheck01Variants } from './IconFileCheck01';
import { variants as FileCheck02Variants } from './IconFileCheck02';
import { variants as FileDownload02Variants } from './IconFileDownload02';
import { variants as FileDownload03Variants } from './IconFileDownload03';
import { variants as FileSearch01Variants } from './IconFileSearch01';
import { variants as FilterLinesVariants } from './IconFilterLines';
import { variants as FirstPageVariants } from './IconFirstPage';
import { variants as FixGrammarVariants } from './IconFixGrammar';
import { variants as Flag01Variants } from './IconFlag01';
import { variants as FlipBackwardVariants } from './IconFlipBackward';
import { variants as FlipForwardPlusVariants } from './IconFlipForwardPlus';
import { variants as FocusVariants } from './IconFocus';
import { variants as FolderVariants } from './IconFolder';
import { variants as FormattingVariants } from './IconFormatting';
import { variants as FormattingListVariants } from './IconFormattingList';
import { variants as FormattingQuoteVariants } from './IconFormattingQuote';
import { variants as Forward10sVariants } from './IconForward10s';
import { variants as FrontLogoVariants } from './IconFrontLogo';
import { variants as GeometryVariants } from './IconGeometry';
import { variants as GifVariants } from './IconGif';
import { variants as Gift01Variants } from './IconGift01';
import { variants as GitBranch01Variants } from './IconGitBranch01';
import { variants as GitPullRequestVariants } from './IconGitPullRequest';
import { variants as Globe01Variants } from './IconGlobe01';
import { variants as Globe04Variants } from './IconGlobe04';
import { variants as GoToConversationVariants } from './IconGoToConversation';
import { variants as GrabHandleVariants } from './IconGrabHandle';
import { variants as GraduationHat01Variants } from './IconGraduationHat01';
import { variants as Grid01Variants } from './IconGrid01';
import { variants as Hash02Variants } from './IconHash02';
import { variants as HeartVariants } from './IconHeart';
import { variants as HelpCenterVariants } from './IconHelpCenter';
import { variants as HelpCircleVariants } from './IconHelpCircle';
import { variants as Home05Variants } from './IconHome05';
import { variants as Hourglass02Variants } from './IconHourglass02';
import { variants as HourglassCheckVariants } from './IconHourglassCheck';
import { variants as Image03Variants } from './IconImage03';
import { variants as Inbox01Variants } from './IconInbox01';
import { variants as InboxListVariants } from './IconInboxList';
import { variants as InfoCircleVariants } from './IconInfoCircle';
import { variants as InfoHistoryVariants } from './IconInfoHistory';
import { variants as Italic01Variants } from './IconItalic01';
import { variants as Keyboard02Variants } from './IconKeyboard02';
import { variants as LaptopVariants } from './IconLaptop';
import { variants as LastPageVariants } from './IconLastPage';
import { variants as LayersThree01Variants } from './IconLayersThree01';
import { variants as LayoutAlt01Variants } from './IconLayoutAlt01';
import { variants as LayoutAlt02Variants } from './IconLayoutAlt02';
import { variants as LayoutGrid02Variants } from './IconLayoutGrid02';
import { variants as LayoutLeftVariants } from './IconLayoutLeft';
import { variants as LayoutRightVariants } from './IconLayoutRight';
import { variants as Lightbulb04Variants } from './IconLightbulb04';
import { variants as Lightning01Variants } from './IconLightning01';
import { variants as LineChartUp01Variants } from './IconLineChartUp01';
import { variants as LinearRuleVariants } from './IconLinearRule';
import { variants as Link03Variants } from './IconLink03';
import { variants as LinkBroken03Variants } from './IconLinkBroken03';
import { variants as LinkExternal02Variants } from './IconLinkExternal02';
import { variants as LinkToVariants } from './IconLinkTo';
import { variants as Lock01Variants } from './IconLock01';
import { variants as LogIn02Variants } from './IconLogIn02';
import { variants as LogOut02Variants } from './IconLogOut02';
import { variants as LogOut04Variants } from './IconLogOut04';
import { variants as LongerVariants } from './IconLonger';
import { variants as Mail01Variants } from './IconMail01';
import { variants as Mail04Variants } from './IconMail04';
import { variants as MailNotificationVariants } from './IconMailNotification';
import { variants as MarkerPin01Variants } from './IconMarkerPin01';
import { variants as Menu01Variants } from './IconMenu01';
import { variants as Menu04Variants } from './IconMenu04';
import { variants as MergeVariants } from './IconMerge';
import { variants as MessagePlusCircleVariants } from './IconMessagePlusCircle';
import { variants as MessageSquare01Variants } from './IconMessageSquare01';
import { variants as MessageTemplateVariants } from './IconMessageTemplate';
import { variants as MessageTextCircle02Variants } from './IconMessageTextCircle02';
import { variants as Microphone01Variants } from './IconMicrophone01';
import { variants as Minimize01Variants } from './IconMinimize01';
import { variants as MinusVariants } from './IconMinus';
import { variants as MinusCircleVariants } from './IconMinusCircle';
import { variants as Moon02Variants } from './IconMoon02';
import { variants as NumbersVariants } from './IconNumbers';
import { variants as OpenVariants } from './IconOpen';
import { variants as OutboxVariants } from './IconOutbox';
import { variants as PackageVariants } from './IconPackage';
import { variants as PaperclipVariants } from './IconPaperclip';
import { variants as ParagraphSpacingVariants } from './IconParagraphSpacing';
import { variants as PauseVariants } from './IconPause';
import { variants as PauseCircleVariants } from './IconPauseCircle';
import { variants as Pencil01Variants } from './IconPencil01';
import { variants as PhoneVariants } from './IconPhone';
import { variants as PhoneCall01Variants } from './IconPhoneCall01';
import { variants as PhoneCall03Variants } from './IconPhoneCall03';
import { variants as PhoneCallAnsweredVariants } from './IconPhoneCallAnswered';
import { variants as PhoneCallEndedVariants } from './IconPhoneCallEnded';
import { variants as PhoneHangUpVariants } from './IconPhoneHangUp';
import { variants as PhoneIncoming01Variants } from './IconPhoneIncoming01';
import { variants as PhoneOutgoing01Variants } from './IconPhoneOutgoing01';
import { variants as PhoneOutgoing02Variants } from './IconPhoneOutgoing02';
import { variants as PhonePauseVariants } from './IconPhonePause';
import { variants as PhoneXVariants } from './IconPhoneX';
import { variants as PieChart01Variants } from './IconPieChart01';
import { variants as Pin02Variants } from './IconPin02';
import { variants as PlaneVariants } from './IconPlane';
import { variants as PlayVariants } from './IconPlay';
import { variants as PlayCircleVariants } from './IconPlayCircle';
import { variants as PlaybookTemporaryVariants } from './IconPlaybookTemporary';
import { variants as PlusVariants } from './IconPlus';
import { variants as PlusCircleVariants } from './IconPlusCircle';
import { variants as PrinterVariants } from './IconPrinter';
import { variants as PuzzlePieceVariants } from './IconPuzzlePiece';
import { variants as QASmartVariants } from './IconQASmart';
import { variants as RefreshCw01Variants } from './IconRefreshCw01';
import { variants as RefreshCw02Variants } from './IconRefreshCw02';
import { variants as ReopenVariants } from './IconReopen';
import { variants as Repeat01Variants } from './IconRepeat01';
import { variants as Repeat02Variants } from './IconRepeat02';
import { variants as ReplaceAllVariants } from './IconReplaceAll';
import { variants as Rewind10sVariants } from './IconRewind10s';
import { variants as Rocket02Variants } from './IconRocket02';
import { variants as RuleTesterVariants } from './IconRuleTester';
import { variants as SaveVariants } from './IconSave';
import { variants as ScheduleVariants } from './IconSchedule';
import { variants as SearchSmVariants } from './IconSearchSm';
import { variants as SendVariants } from './IconSend';
import { variants as Send04Variants } from './IconSend04';
import { variants as SendOptionsVariants } from './IconSendOptions';
import { variants as Settings02Variants } from './IconSettings02';
import { variants as Settings03Variants } from './IconSettings03';
import { variants as ShiftVariants } from './IconShift';
import { variants as ShorterVariants } from './IconShorter';
import { variants as ShuffleVariants } from './IconShuffle';
import { variants as SidebarVariants } from './IconSidebar';
import { variants as SlashCircle01Variants } from './IconSlashCircle01';
import { variants as Sliders04Variants } from './IconSliders04';
import { variants as SmsVariants } from './IconSms';
import { variants as SplitVariants } from './IconSplit';
import { variants as SquareVariants } from './IconSquare';
import { variants as Star04Variants } from './IconStar04';
import { variants as Stars01Variants } from './IconStars01';
import { variants as StatusChangeVariants } from './IconStatusChange';
import { variants as StickerSquareVariants } from './IconStickerSquare';
import { variants as Strikethrough01Variants } from './IconStrikethrough01';
import { variants as SunVariants } from './IconSun';
import { variants as SwitchHorizontal01Variants } from './IconSwitchHorizontal01';
import { variants as SwitchVertical01Variants } from './IconSwitchVertical01';
import { variants as TableVariants } from './IconTable';
import { variants as Tag03Variants } from './IconTag03';
import { variants as Tag04Variants } from './IconTag04';
import { variants as Target03Variants } from './IconTarget03';
import { variants as TargetOffVariants } from './IconTargetOff';
import { variants as TaskVariants } from './IconTask';
import { variants as TaskTemplateVariants } from './IconTaskTemplate';
import { variants as TemplateVariants } from './IconTemplate';
import { variants as ThumbsDownVariants } from './IconThumbsDown';
import { variants as ThumbsUpVariants } from './IconThumbsUp';
import { variants as Ticket01Variants } from './IconTicket01';
import { variants as ToolVariants } from './IconTool';
import { variants as Translate01Variants } from './IconTranslate01';
import { variants as Trash03Variants } from './IconTrash03';
import { variants as Truck01Variants } from './IconTruck01';
import { variants as TwitterXVariants } from './IconTwitterX';
import { variants as TypeStrikethrough01Variants } from './IconTypeStrikethrough01';
import { variants as Umbrella03Variants } from './IconUmbrella03';
import { variants as UnassignedVariants } from './IconUnassigned';
import { variants as Underline01Variants } from './IconUnderline01';
import { variants as UnpinVariants } from './IconUnpin';
import { variants as User01Variants } from './IconUser01';
import { variants as UserCheck01Variants } from './IconUserCheck01';
import { variants as UserCircleVariants } from './IconUserCircle';
import { variants as UserEditVariants } from './IconUserEdit';
import { variants as UserLeft01Variants } from './IconUserLeft01';
import { variants as UserPlus01Variants } from './IconUserPlus01';
import { variants as UserRight01Variants } from './IconUserRight01';
import { variants as UserRightOffVariants } from './IconUserRightOff';
import { variants as UserSparkle01Variants } from './IconUserSparkle01';
import { variants as UserX01Variants } from './IconUserX01';
import { variants as UsersVariants } from './IconUsers';
import { variants as Users01Variants } from './IconUsers01';
import { variants as UsersLeftVariants } from './IconUsersLeft';
import { variants as UsersPlusVariants } from './IconUsersPlus';
import { variants as VariableVariants } from './IconVariable';
import { variants as VideoRecorderVariants } from './IconVideoRecorder';
import { variants as ViewsVariants } from './IconViews';
import { variants as VisitorSourceVariants } from './IconVisitorSource';
import { variants as VoicemailVariants } from './IconVoicemail';
import { variants as VolumeMaxVariants } from './IconVolumeMax';
import { variants as WhatsappVariants } from './IconWhatsapp';
import { variants as WorkspaceVariants } from './IconWorkspace';
import { variants as WorkspaceStrokeVariants } from './IconWorkspaceStroke';
import { variants as XCircleVariants } from './IconXCircle';
import { variants as XCloseVariants } from './IconXClose';

export const ICON_VARIANTS = {
  'add-column-left': AddColumnLeftVariants,
  'add-column-right': AddColumnRightVariants,
  'add-link': AddLinkVariants,
  'add-reaction': AddReactionVariants,
  'add-row-above': AddRowAboveVariants,
  'add-row-below': AddRowBelowVariants,
  'adjust-tone': AdjustToneVariants,
  'ai': AiVariants,
  'ai-agent': AiAgentVariants,
  'ai-compose': AiComposeVariants,
  'alarm-clock': AlarmClockVariants,
  'alert-circle': AlertCircleVariants,
  'alert-hexagon': AlertHexagonVariants,
  'alert-square': AlertSquareVariants,
  'alert-triangle': AlertTriangleVariants,
  'align-left': AlignLeftVariants,
  'align-vertical-center': AlignVerticalCenterVariants,
  'archive': ArchiveVariants,
  'archive-off': ArchiveOffVariants,
  'arrow-block-left': ArrowBlockLeftVariants,
  'arrow-block-right': ArrowBlockRightVariants,
  'arrow-circle-broken-right': ArrowCircleBrokenRightVariants,
  'arrow-narrow-down': ArrowNarrowDownVariants,
  'arrow-narrow-down-right': ArrowNarrowDownRightVariants,
  'arrow-narrow-left': ArrowNarrowLeftVariants,
  'arrow-narrow-right': ArrowNarrowRightVariants,
  'arrow-narrow-up': ArrowNarrowUpVariants,
  'arrow-narrow-up-right': ArrowNarrowUpRightVariants,
  'at-sign': AtSignVariants,
  'audit-log': AuditLogVariants,
  'autopilot': AutopilotVariants,
  'badge-counter': BadgeCounterVariants,
  'bar-chart-01': BarChart01Variants,
  'bar-chart-10': BarChart10Variants,
  'bell-01': Bell01Variants,
  'bell-off-01': BellOff01Variants,
  'block-corner-up-left': BlockCornerUpLeftVariants,
  'block-corner-up-right': BlockCornerUpRightVariants,
  'bold-01': Bold01Variants,
  'book-closed': BookClosedVariants,
  'book-open-01': BookOpen01Variants,
  'bookmark': BookmarkVariants,
  'brackets-ellipses': BracketsEllipsesVariants,
  'brain': BrainVariants,
  'branching-rule': BranchingRuleVariants,
  'briefcase-01': Briefcase01Variants,
  'briefcase-01-plus': Briefcase01PlusVariants,
  'briefcase-02': Briefcase02Variants,
  'building-05': Building05Variants,
  'business-hours': BusinessHoursVariants,
  'calendar': CalendarVariants,
  'calendar-check-02': CalendarCheck02Variants,
  'calendar-date': CalendarDateVariants,
  'calendar-plus-02': CalendarPlus02Variants,
  'caret-collapse': CaretCollapseVariants,
  'caret-expand': CaretExpandVariants,
  'caret-up-down': CaretUpDownVariants,
  'chat': ChatVariants,
  'chat-deflected': ChatDeflectedVariants,
  'check': CheckVariants,
  'check-circle': CheckCircleVariants,
  'check-square': CheckSquareVariants,
  'check-verified-02': CheckVerified02Variants,
  'chevron-down': ChevronDownVariants,
  'chevron-left': ChevronLeftVariants,
  'chevron-right': ChevronRightVariants,
  'chevron-up': ChevronUpVariants,
  'circle': CircleVariants,
  'clock': ClockVariants,
  'clock-check': ClockCheckVariants,
  'clock-recently-viewed': ClockRecentlyViewedVariants,
  'clock-rewind': ClockRewindVariants,
  'clock-snooze': ClockSnoozeVariants,
  'cloud-off': CloudOffVariants,
  'code-01': Code01Variants,
  'columns-03': Columns03Variants,
  'compass': CompassVariants,
  'connectors': ConnectorsVariants,
  'contact-auto': ContactAutoVariants,
  'contrast-02': Contrast02Variants,
  'conversation': ConversationVariants,
  'conversation-search': ConversationSearchVariants,
  'copilot': CopilotVariants,
  'copy-01': Copy01Variants,
  'copy-06': Copy06Variants,
  'copy-file': CopyFileVariants,
  'corner-down-right': CornerDownRightVariants,
  'corner-up-left': CornerUpLeftVariants,
  'corner-up-left-double': CornerUpLeftDoubleVariants,
  'corner-up-right': CornerUpRightVariants,
  'cpu-chip-01': CpuChip01Variants,
  'credit-card-02': CreditCard02Variants,
  'crown': CrownVariants,
  'cube-01': Cube01Variants,
  'cube-01-off': Cube01OffVariants,
  'cube-outline': CubeOutlineVariants,
  'currency-dollar': CurrencyDollarVariants,
  'cursor-click': CursorClickVariants,
  'customer-portal': CustomerPortalVariants,
  'dataflow-02': Dataflow02Variants,
  'delete': DeleteVariants,
  'deliverability': DeliverabilityVariants,
  'diamond-01': Diamond01Variants,
  'discussions': DiscussionsVariants,
  'discussions-depreciated': DiscussionsDepreciatedVariants,
  'distribute-spacing-vertical': DistributeSpacingVerticalVariants,
  'divider': DividerVariants,
  'donut-chart': DonutChartVariants,
  'door-open': DoorOpenVariants,
  'dot': DotVariants,
  'dotpoints-01': Dotpoints01Variants,
  'dots-grid': DotsGridVariants,
  'dots-horizontal': DotsHorizontalVariants,
  'dots-vertical': DotsVerticalVariants,
  'download-02': Download02Variants,
  'edit-01': Edit01Variants,
  'edit-05': Edit05Variants,
  'emoji': EmojiVariants,
  'emoji-activity': EmojiActivityVariants,
  'emoji-food': EmojiFoodVariants,
  'emoji-nature': EmojiNatureVariants,
  'emoji-symbols': EmojiSymbolsVariants,
  'expand-01': Expand01Variants,
  'export': ExportVariants,
  'eye': EyeVariants,
  'eye-off': EyeOffVariants,
  'face-happy': FaceHappyVariants,
  'face-smile': FaceSmileVariants,
  'feather': FeatherVariants,
  'field-custom': FieldCustomVariants,
  'file-02': File02Variants,
  'file-05': File05Variants,
  'file-check-01': FileCheck01Variants,
  'file-check-02': FileCheck02Variants,
  'file-download-02': FileDownload02Variants,
  'file-download-03': FileDownload03Variants,
  'file-search-01': FileSearch01Variants,
  'filter-lines': FilterLinesVariants,
  'first-page': FirstPageVariants,
  'fix-grammar': FixGrammarVariants,
  'flag-01': Flag01Variants,
  'flip-backward': FlipBackwardVariants,
  'flip-forward-plus': FlipForwardPlusVariants,
  'focus': FocusVariants,
  'folder': FolderVariants,
  'formatting': FormattingVariants,
  'formatting-list': FormattingListVariants,
  'formatting-quote': FormattingQuoteVariants,
  'forward-10s': Forward10sVariants,
  'front-logo': FrontLogoVariants,
  'geometry': GeometryVariants,
  'gif': GifVariants,
  'gift-01': Gift01Variants,
  'git-branch-01': GitBranch01Variants,
  'git-pull-request': GitPullRequestVariants,
  'globe-01': Globe01Variants,
  'globe-04': Globe04Variants,
  'go-to-conversation': GoToConversationVariants,
  'grab-handle': GrabHandleVariants,
  'graduation-hat-01': GraduationHat01Variants,
  'grid-01': Grid01Variants,
  'hash-02': Hash02Variants,
  'heart': HeartVariants,
  'help-center': HelpCenterVariants,
  'help-circle': HelpCircleVariants,
  'home-05': Home05Variants,
  'hourglass-02': Hourglass02Variants,
  'hourglass-check': HourglassCheckVariants,
  'image-03': Image03Variants,
  'inbox-01': Inbox01Variants,
  'inbox-list': InboxListVariants,
  'info-circle': InfoCircleVariants,
  'info-history': InfoHistoryVariants,
  'italic-01': Italic01Variants,
  'keyboard-02': Keyboard02Variants,
  'laptop': LaptopVariants,
  'last-page': LastPageVariants,
  'layers-three-01': LayersThree01Variants,
  'layout-alt-01': LayoutAlt01Variants,
  'layout-alt-02': LayoutAlt02Variants,
  'layout-grid-02': LayoutGrid02Variants,
  'layout-left': LayoutLeftVariants,
  'layout-right': LayoutRightVariants,
  'lightbulb-04': Lightbulb04Variants,
  'lightning-01': Lightning01Variants,
  'line-chart-up-01': LineChartUp01Variants,
  'linear-rule': LinearRuleVariants,
  'link-03': Link03Variants,
  'link-broken-03': LinkBroken03Variants,
  'link-external-02': LinkExternal02Variants,
  'link-to': LinkToVariants,
  'lock-01': Lock01Variants,
  'log-in-02': LogIn02Variants,
  'log-out-02': LogOut02Variants,
  'log-out-04': LogOut04Variants,
  'longer': LongerVariants,
  'mail-01': Mail01Variants,
  'mail-04': Mail04Variants,
  'mail-notification': MailNotificationVariants,
  'marker-pin-01': MarkerPin01Variants,
  'menu-01': Menu01Variants,
  'menu-04': Menu04Variants,
  'merge': MergeVariants,
  'message-plus-circle': MessagePlusCircleVariants,
  'message-square-01': MessageSquare01Variants,
  'message-template': MessageTemplateVariants,
  'message-text-circle-02': MessageTextCircle02Variants,
  'microphone-01': Microphone01Variants,
  'minimize-01': Minimize01Variants,
  'minus': MinusVariants,
  'minus-circle': MinusCircleVariants,
  'moon-02': Moon02Variants,
  'numbers': NumbersVariants,
  'open': OpenVariants,
  'outbox': OutboxVariants,
  'package': PackageVariants,
  'paperclip': PaperclipVariants,
  'paragraph-spacing': ParagraphSpacingVariants,
  'pause': PauseVariants,
  'pause-circle': PauseCircleVariants,
  'pencil-01': Pencil01Variants,
  'phone': PhoneVariants,
  'phone-call-01': PhoneCall01Variants,
  'phone-call-03': PhoneCall03Variants,
  'phone-call-answered': PhoneCallAnsweredVariants,
  'phone-call-ended': PhoneCallEndedVariants,
  'phone-hang-up': PhoneHangUpVariants,
  'phone-incoming-01': PhoneIncoming01Variants,
  'phone-outgoing-01': PhoneOutgoing01Variants,
  'phone-outgoing-02': PhoneOutgoing02Variants,
  'phone-pause': PhonePauseVariants,
  'phone-x': PhoneXVariants,
  'pie-chart-01': PieChart01Variants,
  'pin-02': Pin02Variants,
  'plane': PlaneVariants,
  'play': PlayVariants,
  'play-circle': PlayCircleVariants,
  'playbook-temporary': PlaybookTemporaryVariants,
  'plus': PlusVariants,
  'plus-circle': PlusCircleVariants,
  'printer': PrinterVariants,
  'puzzle-piece': PuzzlePieceVariants,
  'q-a-smart': QASmartVariants,
  'refresh-cw-01': RefreshCw01Variants,
  'refresh-cw-02': RefreshCw02Variants,
  'reopen': ReopenVariants,
  'repeat-01': Repeat01Variants,
  'repeat-02': Repeat02Variants,
  'replace-all': ReplaceAllVariants,
  'rewind-10s': Rewind10sVariants,
  'rocket-02': Rocket02Variants,
  'rule-tester': RuleTesterVariants,
  'save': SaveVariants,
  'schedule': ScheduleVariants,
  'search-sm': SearchSmVariants,
  'send': SendVariants,
  'send-04': Send04Variants,
  'send-options': SendOptionsVariants,
  'settings-02': Settings02Variants,
  'settings-03': Settings03Variants,
  'shift': ShiftVariants,
  'shorter': ShorterVariants,
  'shuffle': ShuffleVariants,
  'sidebar': SidebarVariants,
  'slash-circle-01': SlashCircle01Variants,
  'sliders-04': Sliders04Variants,
  'sms': SmsVariants,
  'split': SplitVariants,
  'square': SquareVariants,
  'star-04': Star04Variants,
  'stars-01': Stars01Variants,
  'status-change': StatusChangeVariants,
  'sticker-square': StickerSquareVariants,
  'strikethrough-01': Strikethrough01Variants,
  'sun': SunVariants,
  'switch-horizontal-01': SwitchHorizontal01Variants,
  'switch-vertical-01': SwitchVertical01Variants,
  'table': TableVariants,
  'tag-03': Tag03Variants,
  'tag-04': Tag04Variants,
  'target-03': Target03Variants,
  'target-off': TargetOffVariants,
  'task': TaskVariants,
  'task-template': TaskTemplateVariants,
  'template': TemplateVariants,
  'thumbs-down': ThumbsDownVariants,
  'thumbs-up': ThumbsUpVariants,
  'ticket-01': Ticket01Variants,
  'tool': ToolVariants,
  'translate-01': Translate01Variants,
  'trash-03': Trash03Variants,
  'truck-01': Truck01Variants,
  'twitter-x': TwitterXVariants,
  'type-strikethrough-01': TypeStrikethrough01Variants,
  'umbrella-03': Umbrella03Variants,
  'unassigned': UnassignedVariants,
  'underline-01': Underline01Variants,
  'unpin': UnpinVariants,
  'user-01': User01Variants,
  'user-check-01': UserCheck01Variants,
  'user-circle': UserCircleVariants,
  'user-edit': UserEditVariants,
  'user-left-01': UserLeft01Variants,
  'user-plus-01': UserPlus01Variants,
  'user-right-01': UserRight01Variants,
  'user-right-off': UserRightOffVariants,
  'user-sparkle-01': UserSparkle01Variants,
  'user-x-01': UserX01Variants,
  'users': UsersVariants,
  'users-01': Users01Variants,
  'users-left': UsersLeftVariants,
  'users-plus': UsersPlusVariants,
  'variable': VariableVariants,
  'video-recorder': VideoRecorderVariants,
  'views': ViewsVariants,
  'visitor-source': VisitorSourceVariants,
  'voicemail': VoicemailVariants,
  'volume-max': VolumeMaxVariants,
  'whatsapp': WhatsappVariants,
  'workspace': WorkspaceVariants,
  'workspace-stroke': WorkspaceStrokeVariants,
  'x-circle': XCircleVariants,
  'x-close': XCloseVariants,
} as const;

export type IconName = keyof typeof ICON_VARIANTS;
